
import React from 'react';
import { Trophy, Zap, Heart, Users, Award } from 'lucide-react';

const LeaderboardTips: React.FC = () => {
  return (
    <div className="bg-hormony-beige/10 rounded-lg p-4 mt-8">
      <h3 className="font-semibold flex items-center gap-2 mb-2">
        <Trophy size={18} className="text-hormony-coral" />
        How to Climb the Leaderboard
      </h3>
      <ul className="text-sm space-y-2">
        <li className="flex items-start gap-2">
          <Zap size={16} className="text-hormony-coral mt-0.5" />
          <span>Complete daily lessons to earn points and increase your streak</span>
        </li>
        <li className="flex items-start gap-2">
          <Heart size={16} className="text-hormony-coral mt-0.5" />
          <span>Engage with multiple zones to boost your overall ranking</span>
        </li>
        <li className="flex items-start gap-2">
          <Users size={16} className="text-hormony-coral mt-0.5" />
          <span>Invite friends to join Hormony and earn bonus points</span>
        </li>
        <li className="flex items-start gap-2">
          <Award size={16} className="text-hormony-coral mt-0.5" />
          <span>Earn badges by achieving milestones in different zones</span>
        </li>
      </ul>
    </div>
  );
};

export default LeaderboardTips;
